import { ApolloQueryResult } from "@apollo/client";
import { CompetencyMapQueryResult, CompetencyMapQuestionsQuery, Exact, Scalars } from "@generated/graphql";
import { Stack } from "@mui/material";
import EmptyList from "components/EmptyList";
import Question from "./Question";
import { extractQuestions } from "./utils";

interface QuestionsListProps {
  competencyMap: CompetencyMapQuestionsQuery["competencyMap"];
  refetchCompetencyMapQuestions: (
    variables?:
      | Partial<
          Exact<{
            competencyMapId: Scalars["ID"]["input"];
          }>
        >
      | undefined
  ) => Promise<ApolloQueryResult<CompetencyMapQuestionsQuery>>;
  refetchCompetencyMap: CompetencyMapQueryResult["refetch"];
}

const QuestionsList = ({ competencyMap, refetchCompetencyMapQuestions, refetchCompetencyMap }: QuestionsListProps) => {
  const questions = extractQuestions(competencyMap);

  if (!questions.length) {
    return <EmptyList emptyPlaceholderText='Пока нет вопросов' />;
  }

  return (
    <Stack spacing={1.5}>
      {competencyMap &&
        questions.map((question) => (
          <Question
            key={question.id}
            question={question}
            competencyMapId={competencyMap.id}
            refetch={() => {
              refetchCompetencyMapQuestions();
              refetchCompetencyMap();
            }}
            selectionEntity={{ type: "question", id: question.id }}
            selectionScope='questions'
          />
        ))}
    </Stack>
  );
};

export default QuestionsList;
